
















































import Vue from 'vue'
import { MasterlinkTenantServiceProxy, UpdateTenantDTO } from '@/service-proxies/app-v2/system.service-proxies'

const tenantServiceProxy = new MasterlinkTenantServiceProxy()

export default Vue.extend({
  name: 'UpdateTenantInfoDialog',
  props: {
    visible: { // 是否展示
      type: Boolean,
      default: false
    },
    tenantCode: {
        type: String,
        default: ''
    },
    tenantId: {
        type: String,
        default: ''
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      confirmDirty: false,
      loading: false,
    }
  },

  watch: {
    visible(val) {
      if (!val) {
        // 关闭弹框后清空数据
        setTimeout(() => {
          this.form = this.$form.createForm(this)
          this.confirmDirty = false
        }, 500)
      }
    }
  },
  methods: {

    handleOk() {
      this.loading = true

      this.form.validateFieldsAndScroll((err: any, values: any) => {
        if (err) {
          this.loading = false
          return
        }

        let { newTenantCode } = values
        let params =  { 
          tenantId: this.tenantId, 
          tenantCode: newTenantCode
        } as UpdateTenantDTO

        tenantServiceProxy.updateTenantCode(params).then((res: any) => {
          if (res) {
            this.$message.success(res.msg)
            this.$emit('close', newTenantCode)
          }
        }).finally(()=>{
          this.loading = false
        })
      })
    },
    handleCancel() {
      this.$emit('close')
    }
  }
})
